const initialState = {
  codbrs: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "RE_COD":
      return {
        ...state,
        codbrs: action.payload,
      };
    default:
      return state;
  }
}
